// CSS Modules - component class name prefix: QuickLinks__

<template>
  <ul :class="$style.container">
    <li v-for="(link, index) in quickLinks" :key="index">
      <a :href="link.url" :target="link.newWindow ? '_blank' : '_self'">
        <i :class="['fas', link.icon]"></i><span>{{ link.title }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "QuickLinks",
  props: {
    quickLinks: {
      type: Array,
      default: []
    }
  }
};
</script>

<style module lang="scss">
@import "./QuickLinks.scss";
</style>
